export class IProcessResponseObject {
    IsSuccess: boolean;
    ErrorList: Array<IErrorList>;
    Response: any;
}

export class IFlowData {
    didCompleteRegistration: boolean;
    didCompleteEnrollment: boolean;
    didTimeout: boolean;
    didCancel: boolean;
}

export class IErrorList {
    ErrorMessage: string;
    ErrorCode: string;
    FieldID: string;
    FieldName: string;
}

export class ISocialResponseObject {
    UserName: string;
    UserUID: string;
    EmailAddress: string;
    ProviderUID: string;
    ProviderName: string;
    EmailVerified: string;
}

export class IUrlParameters {
    Loc: string;
    ReturnTo: string;
    LoginReturnTo: string;
    JSCallBack: string;
    ClientID: string;
    PromoCode: string;
    TrackingNumber: string;
    CompanyOptions: string;
    Cv_Ib: string;
    Cv_Ob: string;
    Cv_Tp: string;
    Cv_Ip: string;
    Claims: string;
    Cv_Cb: string;
    PNU: string;   // PNU: Promo for NonLoggedinUser
}

export class IUtaConstants {
    UTA_CHECK_BOX_ONLY: string;
    UTA_OPTIONAL_SCROLL: string;
    UTA_REQUIRED_SCROLL: string;
    WAIVER_OF_CONSUMER_RIGHTS: string;
}

export interface IRegistrationData {
    IsNonUniqueEmail: boolean,
    prepop: string
}

export class IFinalFormObject {
    public FullName: string = '';
    public EmailOffers: any = [];
    public UserID: string = '';
    public FirstName: string = '';
    public MiddleName: string = '';
    public LastName: string = '';
    public Email: string = '';
    public NameSuffix: string = '';
    public Tnc: boolean = false;
    public Password: string = '';
    public MCNoticePopover: any;
    public PopoverContent: any;
    public PPCLink: any;
    public IsMX: any;
    public ProfileDisplayName: any;
    public ProfileAddressLine1: any;
    public ProfileCity: any;
    public ProfileState: any;
    public ProfileZip: any;
    public ProfileCityStateZip: any;
    public ProfileCountry: any;
    public CreditCardType: any;
    public CreditCardLast4Digits: any;
    public ContactDisplayName: any;
    public ContactAddressLine1: any;
    public ContactCity: any;
    public ContactCityStateZip: any;
    public ContactCountry: any;
    public UPSNotificationCheck: any;
    public IsEligibleForMyChoice: any;
}

export class IUtagData {
    site_area: string;
    site_sub_area: string;
    referring_url: string;
    step: string;
    page_name: string;
    page_id: string;
    completion_event: string;
    gross_revenue: string;
    net_revenue: string;
    currency: string;
    journey_step_number: string;
    shipping_package_count: string;
    link_name: string;
    link_page: string;
    link_type: string;
    field_name: string;
    form_name: string;
    form_intent: string;
    event_id: string;
}

export class IVatConstants {
    VAT_REQUIRED: string;
    VAT_OPTIONAL: string;
    VAT_NOT_NEEDED: string;
    VAT_CERTIFIED_CITY_LIST: string;
}

export class ISuffixValues {
    value: string;
    option: string;
}
export class IMyChoiceCountriesArray {
    Code: string;
}

export class IAppConfig {
    idleTimeout: number;
    MaxPaymentMethods: number;
    MaxChooseAddresses: number;
}

export class IAccountOptionsData {
    isBusiness: any;
    isAlcohol: any;       
    isShippingPrescription: any;
    isLicensedForPrescription: any;
    isOnlineOrMailOrder: any;
    vatID: any;
    isDefaultPaymentAccount: any;
    companyName: any;
    unitOfMeasurement: any;
    brokerageCode: any;
    brokerageName: any;
    iobb: string;
    electronicInvoice: any;
    PECInformation: string;
    SDIInformation: string;
    accountInitiatorName: string;
}

export class ICommoditiesData {
    selectedCommodities: any;
    additionalInformation: string;
}

export class IAIAFormObj {
    public PaymentAccountType: any;
    public AccountNumber: any;
    public AccountNickname: any;
    public PostalCode: any;
    public AirFreightAccountNumber: any;
    public AirFreightNickname: any;
    public DocsAndPackagesSelected: boolean = true;
    public MakeDefaultPayment: any;
    public MakeAirFreightDefaultPayment: any;
    public IsPostalRequired: any;
}

export class IOpenAccountForm {
    public IsUS: boolean;
    public IsPR: boolean;
    public IsCA: boolean;
    public IsES: boolean;
    public IsNif: boolean;
    public IsPT: boolean;
    public IsIT: boolean;
    public IsPFC: boolean;
    public IsItVatID: boolean;
    public IsUSOrPR: boolean;
    public IsJP: boolean;
    public IsRU: boolean;
    public PECInformation: string;
    public SDIInformation: string;

    public MAddress: boolean = false;
    public AccountAddress1: string;
    public AccountAddressCityStateZip: string;
    public AddressCountry: string;

    public Tnc: any;
    public CompanyEmail: string;
    public IsLicenced: boolean = true;
    public IsOnline: boolean = true;
    public WillShipPharmaceuticals: boolean = false;    
    public ShouldAddInvoiceAddress: boolean = false;

    public HazmatLink: any;
    public BusinessRegLink: any;
    public DiscountLink: any;

    public AccUsage: string;
    public ElectronicInvoice: boolean = false;
    public IsBillingCenterCountry: any;

    public ShouldDisplayElectronicInvoice: boolean = false;
    public IsBillingCenter: boolean = false;
    public IsDigitalSignature: boolean = false;      
    public CheckBoxCA: boolean;
    public ShouldDisplayBrokerName: boolean = false;
    public ShouldDisplayBusinessMessage: any;
    public ShouldDisplayCompanyName: any;
    public IsPersonalSelected: boolean = true;
    public IsPersonalDisabled: boolean = false;
    public ShouldDisplayCompanyInfo: any;
    public ShouldDisplayBrokerType: boolean = false;
    public ShouldDisplayVAT: any;
    public IsVATRequired: boolean;    
    public IsPrincipalInfoRequired: boolean;

    public AccountOptionsModalToggle: any;
    public HazmatLithiumModalToggle: any;
    public OAFailModalToggle: any;

    public ATCheckBox: boolean;
    public HazmatCheckBox: boolean;
    public BatteriesCheckBox: boolean;
    public FirearmsCheckBox: boolean;
    public AmmunitionCheckBox: boolean;

    public AccNumber: string;
    public IsDefaultPayment: boolean = false;
    public CompanyName: string;
    public BrokerName: string;
    public Pickup: IPickup;

    public AccountInitiatorName: string;
    public PrincipleInfoArray: PrincipleArrayObject;

}

export class PrincipleArrayObject {
    principleInfo?: Array<PrincipleInfotempObject> = [];
}

export class PrincipleInfotempObject {
    keyTo?: string;
    valueTo: string;
    keyFrom?: string;
    valueFrom: string;
}

export class ICommoditiesForm {
    public NonRegulatedCommodities: any;
    public AdditionalDescription: string;
    public AddFreeFormText: boolean;
}

export class ISecureAccountForm {
    public idType: string;
    public idNumber: string;
    public firstName: string;
    public middleInitial: string;
    public lastName: string;
    public birthDate: string;
    public IdList?: any;
}

export class ILookupObject {
    Name: string = "";
    Type: string = "";
    ID: string = "";
    IsSelected: string = "";
}

export class ISecureAccountOptionsData {
    IdType: any;
    IdNumber: string;
    FirstName: string;
    MiddleInitial: string;
    LastName: string;
    BirthDate: string
    Address: {
        AddressLine1: string;
        AddressLine2: string;
        AddressLine3: string;
        City: string;
        State: string;
        PostalCode: string;
        Country: string;
    }
}

export class ISignUpFormObj {
    public IsShown: boolean;
    public IsClosing: boolean;
    public LassoLink: string;
    public IsCn: boolean;
    public IsDev: any;
    public TreatMatrixUrl: any;
    public TermsAndConditionsLink: any;
    public ShouldSendOffers: boolean;
    public UserIDPopover: string;
    public PasswordPopover: string;
    public ShouldDisplayErrorList: boolean;
    public UserIDHeaderPopover: any;
    public NoSpacesPopover: any;
    public NoEmailPopover: any;
    public NoSpecialCharsPopover: any;
    public PasswordCantContainPopover: any;
    public PasswordHeaderPopover: any;
    public LowerCasePopover: any;
    public UpperCasePopover: any;
    public OneNumberPopover: any;
    public SpecialCharPopover: any;
    public UserIdListSent: boolean;
    public ShouldDisplayShow: boolean;
    public IsLoading: boolean;
    public ShowValidations: boolean;
    public Clicked = false;
    public UserIDChecked: boolean;
    public SendOffersCheck: boolean;
    public IsSocialLogin: boolean;
    public IsFailedSocialLogin: boolean;
    public ReservedRegistrationNumber: string;
    public IsNonPostalCountry: boolean;
    public SignUpModalToggle: boolean;
    public IsAndoroidNative: boolean;
    public IsIOSNative: boolean;
    public HideInfo = true;
    public ShowUTA = false;
    public ShowSignUp = true;
    public OfferscheckBoxvalue = false;
    public UserIDSuggestions: any;
    public Number = false;
    public Lowercase = false;
    public Special = false;
    public Uppercase = false;
    public Character = false;
    public sessionFail: boolean;
    public CorrectAsciiChars = false;
    public ShouldDisplayAsciiError = false;
    public ShouldDisplayNameAsciiError = false;
    public Check = false;

    public IsSignUpFlow: any;
    public ShouldDisplayNext: boolean;

    public ShouldDisplayUTACheckbox: any;
    public ShouldDisplay14DayUTA: any;
    public IsUSOrPR: any;

    public NoEmail: boolean;
    public NoSpace: boolean = false;
    public NoSpecialChar: boolean = false;
    public UserIDIsValid: boolean;
    public UserIdHasValue: boolean;
    public WasIDEmailSent: boolean;
    public Gigya: any;
    public Count: number;
    public IsModalFlow: boolean;
    public ToolTipLocation: string;
    public GlobalEmailAllowed: boolean;
    public ShouldDisplayListEmail: boolean;
    public ShowUserValidation: boolean;
    public IsAPIErrorExists: boolean;

    public UIDCheck: boolean;
    public EmailPattern: RegExp;
    public CustomPattern: RegExp;
    public NamePattern: RegExp;
    public ApacCountries = [];
    public UserIDExists: boolean;
    public KisaConsent: boolean;
    public IsSouthKorea: boolean;
}

export class IConfirmationFormObj {
    public IsShown: boolean;
    public IsClosing: boolean;
    public IsModalFlow: boolean;
    public IsSocialLogin: boolean;
    public SocialSite: string;
    public IsNotUniqueEmail: boolean;
    public IsAndoroidNative: boolean;
    public IsIOSNative: boolean;
    public PpcLink: string;
    public IsEmailBasedEnrollment: boolean;
    public IsPhoneBasedEnrollment: boolean;
    public IsLoading: boolean;
    public ServiceCallResponse: any;
    public IsAPIErrorExists: boolean = false;
    public ConfirmationFlow: string;
    public MyChoicePrivacyNoticeLink: string;
}

export class IUTAFormObj {
    public IsShown: boolean;
    public IsClosing: boolean;
    public IsModalFlow: boolean;
    public ShouldDisplayError: boolean;
    public ShouldDisplay14DayUTA: any;
    public UTACheckBoxOnly: any;
    public UTAOptionalScroll: boolean;
    public UTARequiredScroll: any;
    public UTACheckboxDisabled: boolean;
    public MeetsScrollRequirements: boolean;
    public TermsAndConditionsLink: string;
    public IsLoading: boolean;
    public Tnc: boolean;
    public IsAPIErrorExists: boolean
}

export class IChoosePaymentFormObj {
    public HasMadeSelection: boolean;
    public ShowMustMakeSelectionWording: boolean;
    public Payments: any;
    public CPCToken: string;
    public CPCTransactionId: string;
    public AddClicked: boolean;
    public ShouldShowCancelDialog: boolean;
    public MyChoiceCard: {};
    public CPCApi: {};

    public IsAPIErrorExists: boolean;
    public AttemptedPromoCode: any;
    public DicscountAmount: any;
    public DiscountCurrency: any;
    public PremiumCodeDescription: any;
    public IsModalFlow: boolean;
    public IsShown: boolean;

    public MCCollectedAddress: any;
    public MCCollectedName: any;
    public DidUseCPC: boolean = false;
    public CPCPaymentAddress = {};
    public CPCCardData: string = "";
    public CPCPaymentInfo: any
}

export class IRequestNotificationFormObj {
    public IsShown: boolean;
    public EnableNextbtn: boolean;
    public Toggle0: boolean;
    public Toggle1: boolean;
    public IsModalFlow: boolean;
    public EditName: any;
    public IsLoading: any;
}

export class ITimeOutFormObj {
    public IsShown: boolean;
    public SubmitURL: string;
    public Utag: any;
    public UtagData: any;
}

export class IChooseDateFormObj {
    public showSelfEnrollOA: boolean = false;
    public ChosenField: any;
    public IsSaturdayAvailable: any;
    public IsLoading: boolean;
    public DateMoved: boolean;
    public DpVal: Date;
    public Min: any;
    public Max: any;
    public DateOptions: any;
    public NextIsClicked: boolean;
    public FirstAvailableDay: any;
    public DateSelected: boolean;
    public IsShown: boolean;
    public IsModalFlow: boolean;
    public IsAPIErrorExists: boolean;
}

export class IChoosePickupFormObj {
    public selfEnrollOA: boolean = false;
    public IsShown: any;
    public IsSaturdayAvailable: any;
    public EditName: boolean;
    public CurrentKey: any;
    public IsChargable: boolean;
    public IsLoading: boolean;
    public IsAPIErrorExists: boolean
    public SmartPickupTime: string;
    public SaturdaySmartPickupTime: string;
    public IsHazmat: any;
    public Hours: any;
    public Meridian: any;
    public JpPickupOptionsMessage: any;
    public Is24HourCountry: any;
    public TotalDaysSelected: number;
    public SpecificDays: any;
    public SpecificWeekendDays: any;
    public IsOnRoute: boolean;
    public IsDaySpecific: boolean;
    public IsSmart: boolean;
    public ErrorPreferred: boolean;
    public ErrorLatest: boolean;
    public ErrorEarly: boolean;
    public ErrorPreferredSat: boolean;
    public ErrorLatestSat: boolean;
    public ErrorEarlySat: boolean;
    public TempDaysHolder: any;
    public IsEmptyValue: boolean;
    public IsdaySelected: boolean;
    public IsFormValid: boolean
    public ETime: boolean;
    public LTime: boolean;
    public IsPickupLocationValid: any;
    public IsNextClicked: boolean;
    public IsModalFlow: boolean;
    public AddressData: IAddressData;
    public ServiceCallResponse: any;
    public IsWeekendSmartPickUpAvailable: boolean;
    public IsWeekendPickupLocationValid: boolean;
    public IsSaturdayEligibleCommercial: string;
    public IsUS: boolean;
    public AtleastOneDaySelected: boolean = false;
    public showSEC: boolean = false;
}

export class IDTOLinks {
    public hazmatLink: any;
    public lithiumLink: any;
    public tarriffAndTermsLink: any;
    public destinationCountriesLink: any;
    public compliantShippingSystemsLink: any;
    public internationalDangerousGoodsLink: any;
    public tariffAndTermsLink: any;
}

export class IOAConfirmData {
    public MycNoticePopover: string;
    public DiscountInformation: any;
    public Name: string;
    public Email: string;
    public UserId: string;
    public UpsNotificationCheck: boolean;
    public PopoverContent: any;
    public IsMX: boolean;
    public MyChoicePrivacyNoticeLink: string;
    public Account: string;
    public PickupOption: number;
    public ProfileCountry: string;
    public ProfileZip: string;
    public WasHazmatChecked: any;
    public WasDangerousGoodsChecked: any;
    public WasLithiumBatteriesChecked: any;
    public WasFirearmsChecked: any;
    public WasAmmunitionChecked: any;
    public StartDate: string;
    public SpecificPickupDays: string;

    public ShouldDisplayDefaultWelcome: boolean;
    public ShouldDisplayBillingCenterWelcome: boolean;
    public ShouldDisplayAltBillingCenterWelcome: boolean;
    public PpcLink: any;
    public DiscountWasUsed: boolean;
    public DiscountName: boolean;
    public DiscountDetails: boolean;
    public ShouldDisplayDiscountTermsLink: boolean;
    public DiscountTermsLink: boolean;
    public FirstName: any;
    public IsEligibleForMyChoice: boolean;
    public IsSaturdayAvailable: any;
    public WeekendPickupOption: number;
    public DiscountHasError: boolean;
}

export class IOAFailData {
    public IsUS: boolean;
    public Default: boolean = false;
    public ContactUPS: boolean = false;
    public BillingSystemFailure: boolean = false;
    public BillingAddressFailure: boolean = false;
    public IsEU: boolean = false;
    public IsCA: boolean = false;
    public IsPR: boolean = false;
    public IsAlcohol: boolean = false;
    public IsAmmunition: boolean = false;
    public SpecialShippingNeedsFailure: boolean = false;
    public CustomerServiceNumber: string;
    public CustomerServiceHelpNumber: string;
}

export class IPickup {
    public UnitsOfMeasurement: string;
    public BrokerType: string;

}

export interface IVatConstants {
    VAT_REQUIRED: string,
    VAT_OPTIONAL: string,
    VAT_NOT_NEEDED: string,
    VAT_CERTIFIED_CITY_LIST: string
}

export interface IAppConfig {
    idleTimeout: number,
    MaxPaymentMethods: number,
    MaxChooseAddresses: number
}

export class IFormData {
    FullName: string;
    EmailOffers: any;
    UserID: string;
    FirstName: string;
    MiddleName: string;
    LastName: string;
    Email: string;
    Password: string;
    NameSuffix: string;
    Tnc: boolean;
}

export class IAddressFormData {
    UpsPromoCode: string;
    TermsConditions: boolean;
    SaveAddress: boolean;
    PhoneType: string;
    Country: string;
    AttemptedPromoCode: string;
    MyChoiceTermsLink: string;
    Zipcode: string;
}

export class ICollectPromoData {
    PromoCode: string;
    AccountNumber: string;
    UserId: string;
    Language: string;
    Country: string;
    WantsOverride: boolean;
}

export class IMCCountryList {
    code: string;
    country: string;
}

export class IAddressData {
    Country: string;
    CountryCode: string;
    AddressLine1: string;
    AddressLine2: string;
    AddressLine3: string;
    City: string;
    StateProvince: string;
    StateProvinceCode: string;
    PostalCode: string;
    ContactName: string;
    EmailAddress: string;
    Phone: string;
    AddressPhone: {
        Number: string;
        Extension: string;
    }
}

export class IPrepopData {
    PhoneNumber: string;
    ContactName: string;
    EmailAddress: string;
    UserID: string;
    ErrorCode: string;
}

export class ITrackingDetails {
    Type: {
        Code: string;
        Description: string;
    }
    CompanyName: string;
    AttentionName: string;
    Address: {
        CountryCode: string;
        AddressLine: string;
        City: string;
        StateProvinceCode: string;
        PostalCode: string;
    }
}

export class ICheckData {
    Country: string;
    Postalcode: string;
}